import React from "react";

const FAQS = [
  {q:"How long does shipping take?", a:"Standard orders ship in 3–5 business days. Free shipping on orders over $75."},
  {q:"Can I request a custom design?", a:"Absolutely — visit our Custom Design Request page. A $5.00 design service fee applies."},
  {q:"What are your apparel sizes?", a:"We carry S through 5XL. Sizes 3XL and up include a $5.00 upcharge."},
  {q:"Do you offer refunds?", a:"Custom apparel is final sale, but we'll always make it right if there's a defect or shipping issue."},
  {q:"How do I track my order?", a:"Use your order number on our Track Order page or the link in your confirmation email."},
];
export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="faq-page">
      <div className="text-xs tracking-widest uppercase text-neutral-500 mb-2">Answers</div>
      <h1 className="font-display text-6xl text-[color:var(--hb-navy)] mb-8">Frequently Asked</h1>
      <div className="divide-y divide-neutral-200 border-y border-neutral-200">
        {FAQS.map((f,i)=>(
          <details key={i} className="py-5 group" data-testid={`faq-${i}`}>
            <summary className="cursor-pointer flex items-center justify-between font-medium">{f.q}<span className="text-neutral-400 group-open:rotate-45 transition">+</span></summary>
            <p className="text-sm text-neutral-700 mt-3">{f.a}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
